import { ExportedPage } from '~/types/canvas/exported-page'
import PDFWorker from '~/server/export/pdf-worker?worker'
import type { WorkerMessage } from './pdf-worker'
import { setLoadingState } from '~/services/loading/loading'
import { translations } from '~/translations'

const getPDF = (pages: ExportedPage[], compress: boolean = true) => {
  return new Promise<Blob>((resolve, reject) => {
    try{
      const worker = new PDFWorker
      worker.onmessage = (event) => {
        const message = event.data as WorkerMessage
        
        if(message.type === 'progress') {
          setLoadingState({
            loading: true,
            message: `PDF: ${translations().loading.transcriptionImage} ${message.currentPage} ${translations().loading.transcriptionOutOf} ${message.totalPages}`
          })
        } else if(message.type === 'completed') {
          resolve(message.blob)
          worker.terminate()
        }
      }
      worker.postMessage({ pages, compress })
    } catch (error) {
      reject(error)
    }
  })
}

export {
  getPDF
}